export const LOCALE_STORAGE_KEY = "yongyuan-locale";
